import { Expose, Transform } from 'class-transformer';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';

export class WorkingTimeModel {
  public id? = null;

  @Transform(({ value }) => value, { toClassOnly: true })
  @Transform(({ value }) => value, { toPlainOnly: true })
  @Expose({ name: 'monday' })
  public monday?: number | null = null;

  @Transform(({ value }) => value, { toClassOnly: true })
  @Transform(({ value }) => value, { toPlainOnly: true })
  @Expose({ name: 'tuesday' })
  public tuesday?: number | null = null;

  @Transform(({ value }) => value, { toClassOnly: true })
  @Transform(({ value }) => value, { toPlainOnly: true })
  @Expose({ name: 'wednesday' })
  public wednesday?: number | null = null;

  @Transform(({ value }) => value, { toClassOnly: true })
  @Transform(({ value }) => value, { toPlainOnly: true })
  @Expose({ name: 'thursday' })
  public thursday?: number | null = null;

  @Transform(({ value }) => value, { toClassOnly: true })
  @Transform(({ value }) => value, { toPlainOnly: true })
  @Expose({ name: 'friday' })
  public friday?: number | null = null;

  @Transform(({ value }) => value, { toClassOnly: true })
  @Transform(({ value }) => value, { toPlainOnly: true })
  @Expose({ name: 'saturday' })
  public saturday?: number | null = null;

  @Transform(({ value }) => value, { toClassOnly: true })
  @Transform(({ value }) => value, { toPlainOnly: true })
  @Expose({ name: 'sunday' })
  public sunday?: number | null = null;

  @Expose({ name: 'starting_from' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public startingFrom: Date | null;

  @Expose({ name: 'user_id' })
  public userId: number | null = null;
}
